import { useMemo } from 'react';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';

const libraries = ['places'];

/** react-snap uses this UA; loading Maps during prerender injects script tags into saved HTML and breaks real browsers (initMap is not a function). */
const isReactSnapPrerender = () =>
  typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent);

const parseCoord = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const n = typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'));
  return Number.isFinite(n) ? n : null;
};

const mapShellStyle = {
  width: '100%',
  height: '55vh',
  minHeight: '280px',
  background: '#eee',
};

const MapPrerenderPlaceholder = () => (
  <div className="map-block map-block--loading" style={mapShellStyle} aria-hidden />
);

const MapWithGoogle = ({ pageData }) => {
  const lat = parseCoord(pageData?.lat);
  const lng = parseCoord(pageData?.lng);

  const mapContainerStyle = useMemo(
    () => ({
      width: '100%',
      height: '55vh',
      minHeight: '280px',
    }),
    []
  );

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
    libraries,
  });

  if (lat == null || lng == null) {
    return null;
  }

  const center = { lat, lng };

  if (loadError) {
    return (
      <div className="map-block map-block--error" style={{ padding: '1rem', color: '#999' }}>
        Map could not be loaded.
      </div>
    );
  }

  if (!isLoaded) {
    return (
      <div
        className="map-block map-block--loading"
        style={{ ...mapShellStyle }}
        aria-hidden
      />
    );
  }

  return (
    <GoogleMap mapContainerStyle={mapContainerStyle} center={center} zoom={14}>
      <Marker position={center} />
    </GoogleMap>
  );
};

const Map = ({ pageData }) => {
  const lat = parseCoord(pageData?.lat);
  const lng = parseCoord(pageData?.lng);

  if (lat == null || lng == null) {
    return null;
  }

  if (isReactSnapPrerender()) {
    return <MapPrerenderPlaceholder />;
  }

  return <MapWithGoogle pageData={pageData} />;
};

export default Map;
